import axios from "axios";
import { timingReloadPage } from "../utils";
import { AUTH_PROCESS_ROOT } from "./api-urls";
import { RELOAD_PAGE_TIME } from "./program-config";
import { contentApiUrl, identityApiUrl } from "./base-urls";
export { env } from "./base-urls";

/*import { GET_STORAGE, REMOVE_STORAGE, SET_STORAGE } from "../utils";
import history from "../utils/history";
import { LOGIN } from "../routes/constants";
import * as Sentry from "@sentry/browser";*/

const requestHandler = (req) => {
    /*if (req.baseURL !== identityApiUrl) {
        const accessToken = GET_STORAGE("user")?.accessToken;

        if (accessToken) {
            req.headers["Authorization"] = `Bearer ${accessToken}`;
        }
    }*/
    return req;
};

const errorHandler = (error) => {
    if (error?.config?.url?.indexOf(AUTH_PROCESS_ROOT) === -1) {
        timingReloadPage(RELOAD_PAGE_TIME)
    }
    /*const originalRequest = error?.config;

    if (error?.response && error?.response?.status === 401 && !originalRequest._retry) {
        const storageRefreshToken = GET_STORAGE("user")?.refreshToken;

        originalRequest._retry = true;
        return identityApi.get(`/Auth/access-tokens/${storageRefreshToken}/iddaa-tv/refresh`).then((response) => {
            if (response?.data?.isSuccess) {
                const { accessToken, refreshToken } = response?.data?.data;
                SET_STORAGE("user", { accessToken, refreshToken });
                originalRequest.headers["Authorization"] = "Bearer " + accessToken;
                return axios(originalRequest);
            } else {
                REMOVE_STORAGE("user");
                REMOVE_STORAGE("is_loggedIn");
                REMOVE_STORAGE("settings");
                history.push(LOGIN);
            }
        }).catch(error => {
            Sentry.captureException(error);
        });
    }*/

    return Promise.reject(error);
};

export const contentApi = axios.create({
    baseURL: contentApiUrl
});

export const identityApi = axios.create({
    baseURL: identityApiUrl
});

export const axiosConfig = () => {
    contentApi.interceptors.request.use((request) => requestHandler(request));

    contentApi.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => errorHandler(error)
    );

    identityApi.interceptors.request.use((request) => requestHandler(request));

    identityApi.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => errorHandler(error)
    );

    Promise.prototype.finally =
        Promise.prototype.finally ||
        {
            finally(fn) {
                const onFinally = (cb) => Promise.resolve(fn()).then(cb);
                return this.then(
                    (result) => onFinally(() => result),
                    (reason) => onFinally(() => Promise.reject(reason))
                );
            }
        }.finally;
};
